module.exports = __webpack_public_path__ + "img/people.0a2c51ee.svg";